<mat-card #displayFilter class="display-filter">
  <card-header [label]="'MENUBAR.DISPLAY_FILTER'| translate" (onClose)="hide()"></card-header>
  <mat-card-content style="margin-top: 8px">
    <div fxLayout="column" fxLayoutAlign="space-around stretch" fxLayoutGap="5px">

      <!-- Maps -->
      <mat-card class="filter-card">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <button disabled="true" mat-button class="filter-button" (click)="onMapsBtnClick()">
            <mat-icon class="filter-icon" svgIcon="maps-filter"></mat-icon>
            <span class="disabledSpan">&nbsp;&nbsp;&nbsp;&nbsp;{{FilterTypeTitles[FilterType.Maps]}}</span>
          </button>
          <div fxFlex></div>
          <mat-slider class="opacity-slider" thumbLabel tickInterval="{{maxBrightness() / 10}}" step="1"
            min="{{minBrightness()}}" max="{{maxBrightness()}}" [value]="mapBrightness"
            (change)="onMapBrightnessSliderChanged($event)">
          </mat-slider>
          <!-- <button mat-icon-button #mapsSettingsBtn (click)="onMapsSettingsBtnClick()"
            [disabled]="mapsSettingsDisabled()"> -->
          <button mat-icon-button #mapsSettingsBtn (click)="onMapsSettingsBtnClick()" [disabled]="true">
            <!-- <mat-icon class="settings-icon" [ngClass]="mapsSettingsDisabled() ? 'svg-icon-disabled' : 'svg-icon'"
              svgIcon="settings"></mat-icon> -->
            <mat-icon class="settings-icon" [ngClass]="true ? 'svg-icon-disabled' : 'svg-icon'" svgIcon="settings">
            </mat-icon>
          </button>
          <button mat-icon-button (click)="onMapsDisplayBtnClick()">
            <mat-icon class="button-icon" inline="true">{{filterOn[FilterType.Maps] ? 'radio_button_checked' :
              'radio_button_unchecked'}}</mat-icon>
          </button>
        </div>
        <div *ngIf="filterExpanded[FilterType.Maps]">
          <mat-selection-list dense>
            <mat-list-option class="selection-list-option" checkboxPosition="before"
              *ngFor="let mapElem of mapElements; index as i" [selected]="mapElementsOn[i]"
              (click)="onMapElemToggle(i)">{{mapElem}}</mat-list-option>
          </mat-selection-list>
        </div>
      </mat-card>

      <!-- Tracks -->
      <mat-card class="filter-card">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <button mat-button class="filter-button" (click)="onTracksBtnClick()">
            <mat-icon class="filter-icon" svgIcon={{trackIcon()}}></mat-icon>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;{{userPerm == 0 ? ('TRACKS.TRACK' | translate) : ('TRACKS.POLYGON' |
              translate)}}</span>
          </button>
          <div fxFlex></div>
          <mat-slider class="opacity-slider" thumbLabel tickInterval="{{maxBrightness() / 10}}" step="1"
            min="{{minBrightness()}}" max="{{maxBrightness()}}" [value]="tracksBrightness"
            (change)="onTracksBrightnessSliderChanged($event)">
          </mat-slider>
          <button mat-icon-button #tracksSettingsBtn (click)="onTracksSettingsBtnClick()"
            [disabled]="tracksSettingsDisabled()">
            <mat-icon class="settings-icon" [ngClass]="tracksSettingsDisabled() ? 'svg-icon-disabled' : 'svg-icon'"
              svgIcon="settings"></mat-icon>
          </button>
          <button mat-icon-button (click)="onTracksDisplayBtnClick()">
            <mat-icon class="button-icon" inline="true">{{filterOn[FilterType.Tracks] ? 'radio_button_checked' :
              'radio_button_unchecked'}}</mat-icon>
          </button>
        </div>
        <div *ngIf="filterExpanded[FilterType.Tracks] && this.userPerm == 0">
          <!-- Hotility -->
          <label class="selection-list-title">{{'DISPLAY_FILTER.FILTER_BY_HOSTILITY' | translate}}</label>
          <div fxlayout="row" class="selection-list-title">
            <label class="textbutton" (click)="trackToggleOnAllHostility()">{{'DISPLAY_FILTER.ALL' | translate}}</label>
            <label> | </label>
            <label class="textbutton" (click)="trackToggleOffAllHostility()">{{'DISPLAY_FILTER.NONE' |
              translate}}</label>
          </div>
          <mat-selection-list dense class="sources-list" style="padding-bottom: 10px;">
            <mat-list-option class="selection-list-option" checkboxPosition="before"
              *ngFor="let trackElem of identityTrackElements; index as i" [selected]="identityTrackElementsOn[i]"
              (click)="onIdentityTrackElemBtnClick(i)">
              {{trackElem}}
            </mat-list-option>
          </mat-selection-list>
          <mat-divider class="selection-list-title" style="margin: 5px; width: 97%;"></mat-divider>
          <!-- Classification -->
          <div class="selection-list-title">{{'DISPLAY_FILTER.FILTER_BY_CLASSIFICATION' | translate}}</div>
          <mat-selection-list dense style="padding-bottom: 10px">
            <mat-list-option class="selection-list-option" checkboxPosition="before"
              *ngFor="let trackElem of clsTrackElements; index as i" [selected]="clsTrackElementsOn[i]"
              (click)="onClsTrackElemBtnClick(i)">{{trackElem}}</mat-list-option>
          </mat-selection-list>
        </div>
      </mat-card>

      <!-- Sensors -->
      <mat-card *ngIf="userPerm == 0" class="filter-card">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <button disabled="false" mat-button class="filter-button" (click)="onSensorsBtnClick()">
            <mat-icon class="filter-icon" svgIcon="sensors-filter"></mat-icon>
            <span class="disabledSpan">&nbsp;&nbsp;&nbsp;&nbsp;{{'DISPLAY_FILTER.SENSOR' | translate}}</span>
          </button>
          <div fxFlex></div>
          <mat-slider class="opacity-slider" thumbLabel tickInterval="{{maxBrightness() / 10}}" step="1"
            min="{{minBrightness()}}" max="{{maxBrightness()}}" [value]="pointsBrightness"
            (change)="onSensorsBrightnessSliderChanged($event)">
          </mat-slider>
          <button mat-icon-button #sensorsSettingsBtn (click)="onSensorsSettingsBtnClick()"
            [disabled]="sensorsSettingsDisabled()">
            <mat-icon class="settings-icon" [ngClass]="sensorsSettingsDisabled() ? 'svg-icon-disabled' : 'svg-icon'"
              svgIcon="settings"></mat-icon>
          </button>
          <button mat-icon-button (click)="onSensorsDisplayBtnClick()">
            <mat-icon class="button-icon" inline="true">{{filterOn[FilterType.Sensors] ? 'radio_button_checked' :
              'radio_button_unchecked'}}</mat-icon>
          </button>
        </div>
        <div *ngIf="filterExpanded[FilterType.Sensors] && this.userPerm == 0">
          <div class="selection-list-title">Filter By Type:</div>
          <mat-selection-list dense style="padding-bottom: 10px">
            <mat-list-option class="selection-list-option" checkboxPosition="before"
              *ngFor="let snsType of snsTypeElements; index as i" [selected]="snsTypeElementsOn[i]"
              (click)="onSnsTypeElemBtnClick(i)">{{snsType}}</mat-list-option>
          </mat-selection-list>
        </div>
      </mat-card>

      <!-- Acoustic Vectors -->
      <mat-card class="filter-card">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <button mat-button class="filter-button" (click)="onAcousticVectorBtnClick()">
            <mat-icon class="filter-icon" svgIcon="lines-filter"></mat-icon>
            <span class="disabledSpan">&nbsp;&nbsp;&nbsp;&nbsp;{{FilterTypeTitles[FilterType.AcousticVector]}}</span>
          </button>
          <div fxFlex></div>
          <mat-slider class="opacity-slider" thumbLabel tickInterval="{{maxBrightness() / 10}}" step="1"
            min="{{minBrightness()}}" max="{{maxBrightness()}}" [value]="maxBrightness()"
            (change)="onAcousticVectorBrightnessSliderChanged($event)">
          </mat-slider>
          <button mat-icon-button #acvecsSettingsBtn (click)="onAcousticVectorSettingsBtnClick()"
            [disabled]="acousticVectorSettingsDisabled()">
            <mat-icon class="settings-icon" [ngClass]="acousticVectorSettingsDisabled() ? 'svg-icon-disabled' : 'svg-icon'"
              svgIcon="settings"></mat-icon>
          </button>
          <button mat-icon-button (click)="onAcousticVectorDisplayBtnClick()">
            <mat-icon class="button-icon" inline="true">{{filterOn[FilterType.AcousticVector] ? 'radio_button_checked' :
              'radio_button_unchecked'}}</mat-icon>
          </button>
        </div>
        <div *ngIf="filterExpanded[FilterType.AcousticVector] && this.userPerm == 0">
          <div class="selection-list-title">Filter Acoustic Lines By Source:</div>
          <mat-selection-list dense style="padding-bottom: 10px">
            <mat-list-option class="selection-list-option" checkboxPosition="before"
              *ngFor="let source of AcousticSources; index as i" [selected]="AcousticSourcesOn[i]"
              (click)="onAcousticSourceBtnClick(i)">{{source}}&nbsp;&nbsp;&nbsp;</mat-list-option>
          </mat-selection-list>
          <div class="selection-list-title">Filter Acoustic Lines By Type:</div>
          <mat-selection-list dense style="padding-bottom: 10px">
            <mat-list-option class="selection-list-option" checkboxPosition="before"
              *ngFor="let type of AcousticVectorTypesOn | keyvalue; trackBy: trackByKey" [selected]="AcousticVectorTypesOn[type.key]"
              (click)="onAcousticVectorTypeBtnClick(type.key)">{{type.key}} &nbsp;&nbsp;&nbsp;</mat-list-option>
          </mat-selection-list>
        </div>
      </mat-card>

      <!-- Plots -->
      <mat-card *ngIf="userPerm == 0" class="filter-card">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <button mat-button class="filter-button" (click)="onPlotsBtnClick()">
            <mat-icon class="filter-icon" svgIcon="plots-filter"></mat-icon>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;{{FilterTypeTitles[FilterType.Plots]}}</span>
          </button>
          <div fxFlex></div>
          <mat-slider class="opacity-slider" thumbLabel tickInterval="{{maxBrightness() / 10}}" step="1"
            min="{{minBrightness()}}" max="{{maxBrightness()}}" [value]="plotsBrightness"
            (change)="onPlotsBrightnessSliderChanged($event)">
          </mat-slider>
          <button mat-icon-button #plotsSettingsBtn (click)="onPlotsSettingsBtnClick()"
            [disabled]="plotsSettingsDisabled()">
            <mat-icon class="settings-icon" [ngClass]="plotsSettingsDisabled() ? 'svg-icon-disabled' : 'svg-icon'"
              svgIcon="settings"></mat-icon>
          </button>
          <button mat-icon-button (click)="onPlotsDisplayBtnClick()">
            <mat-icon class="button-icon" inline="true">{{filterOn[FilterType.Plots] ? 'radio_button_checked' :
              'radio_button_unchecked'}}</mat-icon>
          </button>
        </div>
        <div *ngIf="filterExpanded[FilterType.Plots]">
          <div *ngIf="getPlotsSources().length != 0">
            <label class="selection-list-title">{{'DISPLAY_FILTER.FILTER_BY_SENSORS' | translate}}</label>
            <div fxlayout="row" class="selection-list-title">
              <label class="textbutton" (click)="plotToggleOnAllSrc()">{{'DISPLAY_FILTER.ALL' | translate}}</label>
              <label> | </label>
              <label class="textbutton" (click)="plotToggleOffAllSrc()">{{'DISPLAY_FILTER.NONE' | translate}}</label>
            </div>
            <mat-selection-list dense class="sources-list" style="padding-bottom: 10px;">
              <mat-list-option class="selection-list-option" checkboxPosition="before"
                *ngFor="let plotSrc of getPlotsSources()" [selected]="plotSourceOn(plotSrc)"
                (click)="onPlotSourceToggle(plotSrc)">{{plotSrc}}</mat-list-option>
            </mat-selection-list>
            <mat-divider class="selection-list-title" style="margin: 5px; width: 97%;"></mat-divider>
          </div>
          <label class="selection-list-title">{{'DISPLAY_FILTER.FILTER_BY_TYPE' | translate}}</label>
          <mat-selection-list dense class="sources-list" style="padding-bottom: 10px;">
            <mat-list-option class="selection-list-option" checkboxPosition="before"
              *ngFor="let plotSrc of getPlotTypesSources().slice(2); index as i" [selected]="plotSourceOn(i+2)"
              (click)="onPlotTypeSourceToggle(i+2)">{{plotSrc}}</mat-list-option>
          </mat-selection-list>
        </div>
      </mat-card>

      <!-- NaiNat -->
      <!-- <mat-card *ngIf="userPerm == 0" class="filter-card">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <button disabled="true" mat-button class="filter-button" (click)="onZonesBtnClick()">
            <mat-icon class="filter-icon" svgIcon="zones-filter"></mat-icon>
            <span class="disabledSpan">&nbsp;&nbsp;&nbsp;&nbsp;{{FilterTypeTitles[FilterType.NaiNat]}}</span>
          </button>
          <div fxFlex></div>
          <mat-slider class="opacity-slider" thumbLabel tickInterval="{{maxBrightness() / 10}}" step="1"
            min="{{minBrightness()}}" max="{{maxBrightness()}}" [value]="nainatBrightness"
            (change)="onNaiNatBrightnessSliderChanged($event)">
          </mat-slider>
          <button mat-icon-button #zonesSettingsBtn (click)="onZonesSettingsBtnClick()"
            [disabled]="zonesSettingsDisabled()">
            <mat-icon class="settings-icon" [ngClass]="zonesSettingsDisabled() ? 'svg-icon-disabled' : 'svg-icon'"
              svgIcon="settings"></mat-icon>
          </button>
          <button mat-icon-button (click)="onZonesDisplayBtnClick()">
            <mat-icon class="button-icon" inline="true">{{filterOn[FilterType.NaiNat] ? 'radio_button_checked' :
              'radio_button_unchecked'}}</mat-icon>
          </button>
        </div>
      </mat-card> -->
    </div>
  </mat-card-content>
</mat-card>